import { useNavigate } from 'react-router-dom'

import { F0Button } from '@factorialco/f0-react'

import Callout from 'modules/core/components/Callout'

import { BlockingIssue } from 'modules/integrations/hooks/SyncContext/blockingIssues'

export type BlockingIssuesCalloutProps = {
  blockingIssue: BlockingIssue
}

export function BlockingIssuesCallout({ blockingIssue: validation }: BlockingIssuesCalloutProps) {
  const navigate = useNavigate()

  const buttonAvailable = validation.buttonUrl && validation.buttonLabel

  const linkAction = (
    <F0Button
      variant="outline"
      label={validation.buttonLabel}
      onClick={() => {
        validation.buttonUrl && navigate(validation.buttonUrl)
      }}
    />
  )

  return (
    <Callout
      type="critical"
      title={validation.title}
      description={validation.description}
      action={buttonAvailable ? linkAction : undefined}
    />
  )
}
